import { render, staticRenderFns } from "./ElementBaseInfo.vue?vue&type=template&id=44b92485&scoped=true&"
import script from "./ElementBaseInfo.vue?vue&type=script&lang=js&"
export * from "./ElementBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ElementBaseInfo.vue?vue&type=style&index=0&id=44b92485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b92485",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b92485')) {
      api.createRecord('44b92485', component.options)
    } else {
      api.reload('44b92485', component.options)
    }
    module.hot.accept("./ElementBaseInfo.vue?vue&type=template&id=44b92485&scoped=true&", function () {
      api.rerender('44b92485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/base/ElementBaseInfo.vue"
export default component.exports